import { IApi } from '../../api'
import { ICreateAccessTokenData, IUpdateAccessTokenData } from '../../api/accessTokens'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'accessTokens'

const LIST_ACCESS_TOKENS = createRequestTypes(prefix, 'LIST_ACCESS_TOKENS')

export const [LIST_ACCESS_TOKENS_REQUEST, LIST_ACCESS_TOKENS_SUCCESS, LIST_ACCESS_TOKENS_FAILURE] =
  LIST_ACCESS_TOKENS

export const listAccessTokens = createAction(() => ({
  type: LIST_ACCESS_TOKENS,
  promise: (api: IApi) => api.accessTokens.list(),
}))

const CREATE_ACCESS_TOKEN = createRequestTypes(prefix, 'CREATE_ACCESS_TOKEN')

export const [
  CREATE_ACCESS_TOKEN_REQUEST,
  CREATE_ACCESS_TOKEN_SUCCESS,
  CREATE_ACCESS_TOKEN_FAILURE,
] = CREATE_ACCESS_TOKEN

export const createAccessToken = createAction((data: ICreateAccessTokenData) => ({
  type: CREATE_ACCESS_TOKEN,
  promise: (api: IApi) => api.accessTokens.create(data),
  params: data,
}))

const UPDATE_ACCESS_TOKEN = createRequestTypes(prefix, 'UPDATE_ACCESS_TOKEN')

export const [
  UPDATE_ACCESS_TOKEN_REQUEST,
  UPDATE_ACCESS_TOKEN_SUCCESS,
  UPDATE_ACCESS_TOKEN_FAILURE,
] = UPDATE_ACCESS_TOKEN

export const updateAccessToken = createAction((id: string, data: IUpdateAccessTokenData) => ({
  type: UPDATE_ACCESS_TOKEN,
  promise: (api: IApi) => api.accessTokens.update(id, data),
  params: { id, ...data },
}))

const REVOKE_ACCESS_TOKEN = createRequestTypes(prefix, 'REVOKE_ACCESS_TOKEN')

export const [
  REVOKE_ACCESS_TOKEN_REQUEST,
  REVOKE_ACCESS_TOKEN_SUCCESS,
  REVOKE_ACCESS_TOKEN_FAILURE,
] = REVOKE_ACCESS_TOKEN

export const revokeAccessToken = createAction((id: string) => ({
  type: REVOKE_ACCESS_TOKEN,
  promise: (api: IApi) => api.accessTokens.revoke(id),
  params: { id },
}))

export const CLEAR_CREATED_ACCESS_TOKEN = `${prefix}/CLEAR_CREATED_ACCESS_TOKEN`

/** Drops the one-time plaintext once its dialog closes, so it isn't kept for the session. */
export const clearCreatedAccessToken = () => ({ type: CLEAR_CREATED_ACCESS_TOKEN })
